// extracted by mini-css-extract-plugin
export var button = "newsletter-options-module--button--lnmac";
export var leftWrapper = "newsletter-options-module--left-wrapper--Ai3R7";
export var link = "newsletter-options-module--link--fBXnV";
export var newsletter = "newsletter-options-module--newsletter--9T+Wr";
export var text = "newsletter-options-module--text--aM2WR";
export var title = "newsletter-options-module--title--p9fmg";